import { Injectable } from "@angular/core";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageCapacitor } from "@app/core/share-message/infrastructure/capacitor/share-message.capacitor";

import { Observable } from "rxjs";

@Injectable()
export class ShareMessageCapacitorImplRepo implements ShareMessageRepo {
  constructor(private shareMessageCapacitor: ShareMessageCapacitor) {}

  shareMessage(message: string, url: string): Observable<string> {
    return this.shareMessageCapacitor.execute(message, url);
  }
}
